export default function withoutLeadingSlash(url) {
    return url.replace(/^\//, '');
}
//# sourceMappingURL=index.js.map